<template>
  <LuJhu lu-jhu-type="ZongHeDaXiaoLuJhu" />
</template>

<script>
import LuJhu from '@/components/desktop/common/trend/LuJhu'
export default {
  name: 'ZongHeDaXiao',
  components: {
    LuJhu
  }
}
</script>

